export const siteName = `${process.env.NAME} - ${process.env.DESCRIPTION}`
